const LOW = "LOW";
const MEDIUM = "MEDIUM";
const HIGH = "HIGH";

export const probabilityThresholds = [
  { tag: LOW, threshold: 0.25 },
  { tag: MEDIUM, threshold: 0.5 },
  { tag: HIGH, threshold: 0.75 },
];
